import ListOfBreed from 'component/ListOfBreed/ListOfBreed'

export default function SearchOfBreeds () {
  return <ListOfBreed />
}
